import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="order-actions"
export default class extends Controller {
  static targets = ["button", "card", "input"]

  connect() {
    this.element.addEventListener("click", this.handleClick.bind(this))
  }

  handleClick(event) {
    // Botón preparar (claim)
    const claimButton = event.target.closest(".claim-order-btn")
    if (claimButton && !claimButton.disabled) {
      this.handleClaim(claimButton)
      return
    }

    // Botón listo (mark ready - solo cambia state)
    const markReadyButton = event.target.closest(".mark-ready-btn")
    if (markReadyButton && !markReadyButton.disabled) {
      this.handleMarkReady(markReadyButton)
      return
    }

    // Botón notificar cliente (push + in-app)
    const notifyCustomerButton = event.target.closest(".notify-customer-btn")
    if (notifyCustomerButton && !notifyCustomerButton.disabled) {
      this.handleNotifyCustomer(notifyCustomerButton)
      return
    }

    // Botón despachar delivery
    const dispatchButton = event.target.closest(".dispatch-order-btn")
    if (dispatchButton && !dispatchButton.disabled) {
      this.handleDispatch(dispatchButton)
      return
    }

    // Botón entregada (marcar como delivered desde estación)
    const deliverButton = event.target.closest(".deliver-order-btn")
    if (deliverButton && !deliverButton.disabled) {
      this.handleDeliver(deliverButton)
      return
    }
  }

  handleClaim(button) {
    const orderId = button.dataset.orderId

    this.disableClaim(button)

    fetch(`/orders/${orderId}/claim`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          if (data.delivery_status === "requested") {
            this.showDeliveryStatus(orderId, "Repartidor solicitado 🏍️", "success")
          }
        } else {
          this.enableClaim(button)
          if (data.error) {
            this.showDeliveryStatus(orderId, data.error, "danger")
          }
          if (data.resolution_url) window.location.assign(data.resolution_url)
        }
      })
      .catch(error => {
        console.error("Error:", error)
        alert("Ocurrió un error de red.")
        this.enableClaim(button)
      })
  }

  handleMarkReady(button) {
    const orderId = button.dataset.orderId
    const card = button.closest(".order-card")
    const isPresencial = card?.classList.contains('order-presencial')

    this.disableMarkReady(button, card)

    fetch(`/orders/${orderId}/mark_ready`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
      .then(response => response.json())
      .then(data => {
        if (!data.success) {
          alert(`Error: ${data.error}`)
          this.enableMarkReady(button, card, isPresencial)
        } else {
          // Mostrar botón Notificar
          this.showNotifyButton(card, orderId)
        }
      })
      .catch(error => {
        console.error("Error:", error)
        alert("Ocurrió un error de red.")
        this.enableMarkReady(button, card, isPresencial)
      })
  }

  handleNotifyCustomer(button) {
    const orderId = button.dataset.orderId

    button.disabled = true
    button.innerHTML = '<i class="bi bi-hourglass-split me-1"></i>Enviando...'

    fetch(`/orders/${orderId}/notify_customer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          button.classList.remove('btn-outline-success')
          button.classList.add('btn-outline-secondary')
          button.innerHTML = '<i class="bi bi-check-circle me-1"></i>Notificación enviada'
        } else {
          button.disabled = false
          button.classList.remove('btn-outline-secondary')
          button.classList.add('btn-outline-success')
          button.innerHTML = '<i class="bi bi-bell me-1"></i>Notificar'
          alert(`Error: ${data.error}`)
        }
      })
      .catch(error => {
        console.error("Error:", error)
        button.disabled = false
        button.innerHTML = '<i class="bi bi-bell me-1"></i>Notificar'
        alert("Ocurrió un error de red.")
      })
  }

  handleDispatch(button) {
    const orderId = button.dataset.orderId
    const card = button.closest(".order-card")

    button.disabled = true
    button.innerHTML = '<i class="bi bi-check-circle me-1"></i> Despachado'
    button.classList.remove('btn-delivery')
    button.classList.add('btn-secondary')

    fetch(`/orders/${orderId}/dispatch_delivery`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          const cardContainer = card?.closest('.col-xl-3')
          if (cardContainer) {
            cardContainer.style.transition = 'opacity 0.3s'
            cardContainer.style.opacity = '0'
            setTimeout(() => cardContainer.remove(), 300)
          }
        } else {
          button.disabled = false
          button.classList.remove('btn-secondary')
          button.classList.add('btn-delivery')
          button.innerHTML = '<i class="bi bi-send me-1"></i> Despachado'
          alert(`Error: ${data.error}`)
        }
      })
      .catch(error => {
        console.error("Error:", error)
        button.disabled = false
        button.classList.remove('btn-secondary')
        button.classList.add('btn-delivery')
        button.innerHTML = '<i class="bi bi-send me-1"></i> Despachado'
        alert("Ocurrió un error de red.")
      })
  }

  handleDeliver(button) {
    const orderId = button.dataset.orderId
    const card = document.getElementById(`order-${orderId}`)

    button.disabled = true

    fetch(`/orders/${orderId}/deliver`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          const cardContainer = card?.closest('.col-xl-3')
          if (cardContainer) {
            cardContainer.style.transition = 'opacity 0.3s'
            cardContainer.style.opacity = '0'
            setTimeout(() => cardContainer.remove(), 300)
          }
        } else {
          button.disabled = false
          alert(data.error)
        }
      })
      .catch(() => {
        button.disabled = false
      })
  }

  disableClaim(button) {
    button.disabled = true
    button.classList.remove('btn-prepare')
    button.classList.add('btn-cooking')
    button.innerHTML = `
      <span class="cooking-icon">🍳</span>
      <span class="ms-1">Preparando...</span>
    `

    // Mostrar botón Despachado para delivery
    const card = button.closest('.order-card')
    const dispatchBtn = card?.querySelector('.dispatch-order-btn')
    if (dispatchBtn) {
      dispatchBtn.style.display = ''
    }
  }

  enableClaim(button) {
    button.disabled = false
    button.classList.remove('btn-cooking')
    button.classList.add('btn-prepare')
    button.innerHTML = 'Preparar <i class="bi bi-arrow-right ms-1"></i>'

    // Ocultar botón Despachado si falló
    const card = button.closest('.order-card')
    const dispatchBtn = card?.querySelector('.dispatch-order-btn')
    if (dispatchBtn) {
      dispatchBtn.style.display = 'none'
    }
  }

  disableMarkReady(button, card) {
    // Esconder botón Listo — queda solo Notificar
    button.remove()
    card?.classList.add('order-notified')

    // Ocultar botón Preparar cuando se marca lista
    const claimSection = card?.querySelector('.order-claim')
    if (claimSection) {
      claimSection.remove()
    }

    // Mover card al final de la lista
    const ordersList = document.querySelector('.orders-list')
    const cardContainer = card?.closest('.col-xl-3')
    if (ordersList && cardContainer) {
      ordersList.appendChild(cardContainer)
    }
  }

  enableMarkReady(button, card, isPresencial) {
    // Re-insertar botón Listo si fue removido (rollback on error)
    button.disabled = false
    button.classList.remove('btn-secondary')
    button.classList.add(isPresencial ? 'btn-notify-presencial' : 'btn-notify-online')
    button.innerHTML = '<i class="bi bi-check2-circle me-1"></i>Orden Lista'
    card?.classList.remove('order-notified')
    const actionsDiv = card?.querySelector('.order-actions')
    if (actionsDiv) {
      actionsDiv.prepend(button)
    }
  }

  showNotifyButton(card, orderId) {
    const actionsDiv = card?.querySelector('.order-actions')
    if (!actionsDiv) return

    // Solo agregar si no existe ya
    if (actionsDiv.querySelector('.notify-customer-btn')) return

    const notifyBtn = document.createElement('button')
    notifyBtn.className = 'btn btn-outline-success notify-customer-btn w-100 btn-sm mt-1'
    notifyBtn.dataset.orderId = orderId
    notifyBtn.innerHTML = '<i class="bi bi-bell me-1"></i>Notificar'
    actionsDiv.appendChild(notifyBtn)
  }

  showDeliveryStatus(orderId, message, type) {
    const card = document.getElementById(`order-${orderId}`)
    if (!card) return

    const existing = card.querySelector('.delivery-dispatch-status')
    if (existing) existing.remove()

    const statusDiv = document.createElement('div')
    statusDiv.className = `delivery-dispatch-status alert alert-${type} p-2 m-2 small text-center mb-0`
    statusDiv.textContent = message

    const actions = card.querySelector('.order-actions')
    if (actions) {
      actions.before(statusDiv)
    } else {
      card.appendChild(statusDiv)
    }

    if (type === "success") {
      setTimeout(() => statusDiv.remove(), 8000)
    }
  }
}
